<template>
  <div class='animated fadeIn'>
    <b-tabs>
      <b-tab title='ルーティンリファレンス' :active='tab == 0' @click='tabSelected(0)'>
        <b-card border-variant='white'>
            <b-row>
            <b-col sm='5'><label for='input-none'></label></b-col>
              <div class='ml-auto p-2 align-middle'>
                <el-button type='warning' icon='el-icon-plus' circle v-on:click='addRoutineRefs()'></el-button>
              </div>
            </b-row>
          <b-card-body>
            <b-row>
              <b-col>
                <div class='table-responsive'>
                  <b-table
                    :items='routineRefs'
                    :fields='routineRefsFields'
                    :current-page='routineRefCurrentPage'
                    :per-page='routineRefPerPage'>
                    <div slot='icon' class='avatar' slot-scope='item'>
                      <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                      <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='routine_ref' slot-scope='item'>
                      <div>{{ getGroup(item.value) }}</div>
                    </div>
                    <div slot='name' slot-scope='item'>
                      <p>{{ item.value }}</p>
                    </div>
                    <div slot='startAt' slot-scope='item'>
                      <div>{{new Date(item.value*1000) | momentShort }}</div>
                    </div>
                    <div slot='endAt' slot-scope='item'>
                      <div>{{new Date(item.value*1000) | momentShort }}</div>
                    </div>
                    <div slot='enable' slot-scope='item'>
                      <div v-if='item.value'>有効</div>
                      <div v-else>無効</div>
                    </div>
                    <div slot='key' slot-scope='item'>
                      <p v-if='authUser.role === "admin"' class='small text-muted'>{{ item.value }}</p>
                      <div class='mr-auto p-2 align-middle'>
                        <el-button type='success' icon='el-icon-edit' circle v-on:click='editRoutineRefs(item.value)'></el-button>
                      </div>
                    </div>
                  </b-table>
                </div>
              <b-pagination align='center' size='sm' :total-rows='routineRefs.length' v-model='routineRefCurrentPage' :per-page='routineRefPerPage'>
              </b-pagination>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab title='ルーティングループ' :active='tab == 1' @click='tabSelected(1)'>
        <b-card border-variant='white'>
          <b-row>
            <b-col sm='5'><label for='input-none'></label></b-col>
              <div class='ml-auto p-2 align-middle'>
                <el-button type='warning' icon='el-icon-plus' circle v-on:click='addRoutineGroup()'></el-button>
              </div>
            </b-row>
          <b-card-body>
            <b-row>
              <b-col>
                <div class='table-responsive'>
                  <b-table
                    :items='routineGroups'
                    :fields='routineGroupsFields'
                    :current-page='routineGroupCurrentPage'
                    :per-page='routineGroupPerPage'>
                    <div slot='icon' class='avatar' slot-scope='item'>
                      <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                      <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='routine_ref' slot-scope='item'>
                      <div>{{ getGroup(item.value) }}</div>
                    </div>
                    <div slot='name' slot-scope='item'>
                      <p>{{ item.value }}</p>
                    </div>
                    <div slot='category' slot-scope='item'>
                      <p class='p-0 m-0'>[{{categoryText(item.value)}}]</p>
                    </div>
                    <div slot='routines' slot-scope='item'>
                      <div>{{Object.keys(item.value).length}}</div>
                    </div>
                    <div slot='key' slot-scope='item'>
                      <p v-if='authUser.role === "admin"' class='small text-muted'>{{ item.value }}</p>
                      <div class='mr-auto p-2 align-middle'>
                        <el-button type='success' icon='el-icon-edit' circle v-on:click='editRoutineGroup(item.value)'></el-button>
                      </div>
                    </div>
                  </b-table>
                </div>
              <b-pagination align='center' size='sm' :total-rows='routineGroups.length' v-model='routineGroupCurrentPage' :per-page='routineGroupPerPage'>
              </b-pagination>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab title='ルーティン' :active='tab == 2' @click='tabSelected(2)'>
        <b-card border-variant='white'>
          <b-row>
            <b-col sm='5'><label for='input-none'></label></b-col>
              <div class='ml-auto p-2 align-middle'>
                <el-button type='warning' icon='el-icon-plus' circle v-on:click='addRoutine()'></el-button>
              </div>
            </b-row>
          <b-card-body>
            <b-row>
              <b-col>
                <div class='table-responsive'>
                  <b-table
                    :items='routines'
                    :fields='routinesFields'
                    :current-page='routineCurrentPage'
                    :per-page='routinePerPage'>
                    <div slot='icon' class='avatar' slot-scope='item'>
                      <b-img v-if='item.value' :src='item.value' width='40' height='40'></b-img>
                      <!-- <b-img v-else src='../admin.png' width='40' height='40' class='img-avatar'></b-img> -->
                    </div>
                    <div slot='mediaLink' slot-scope='item'>
                      <b-embed v-if=item.value type='iframe'
                              aspect='16by9'
                              :src=youtube(item.value)
                              allowfullscreen
                      ></b-embed>
                    </div>
                    <div slot='category' slot-scope='item'>
                      <p class='p-0 m-0'>[{{categoryText(item.value)}}]</p>
                    </div>
                    <div slot='key' slot-scope='item'>
                      <p v-if='authUser.role === "admin"' class='small text-muted'>{{ item.value }}</p>
                      <div class='mr-auto p-2 align-middle'>
                        <el-button type='success' icon='el-icon-edit' circle v-on:click='editRoutine(item.value)'></el-button>
                      </div>
                    </div>
                  </b-table>
                </div>
              <b-pagination align='center' size='sm' :total-rows='routines.length' v-model='routineCurrentPage' :per-page='routinePerPage'>
              </b-pagination>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      tab: 0,
      routineRefsFields: {
        title: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        routine_ref: {
          label: 'Routine Group',
          class: 'text-center',
          sortable: true
        },
        startAt: {
          label: '開始日',
          class: 'text-center',
          sortable: true
        },
        endAt: {
          label: '終了日',
          class: 'text-center',
          sortable: true
        },
        enable: {
          label: '有効',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      routineRefCurrentPage: 1,
      routineRefPerPage: 10,
      routineGroupsFields: {
        title: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        subTitle: {
          label: '説明',
          class: 'text-center',
          sortable: true
        },
        category: {
          label: 'Category',
          class: 'text-center',
          sortable: true
        },
        routines: {
          label: '登録数',
          class: 'text-center'
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      routineGroupCurrentPage: 1,
      routineGroupPerPage: 10,
      routinesFields: {
        title: {
          label: 'Routine',
          class: 'text-center',
          sortable: true
        },
        category: {
          label: 'Category',
          class: 'text-center',
          sortable: true
        },
        subTitle: {
          label: '説明',
          class: 'text-center',
          sortable: true
        },
        mediaLink: {
          label: 'YouTube',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      routineCurrentPage: 1,
      routinePerPage: 10
    }
  },
  created () {
    this.tab = this.parameter
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      parameter: 'dispatch/tab',
      authUser: 'authUser/user'
    })
  },
  methods: {
    tabSelected (index) {
      this.tab = index
      this.$store.dispatch('dispatch/setTab', this.tab)
    },
    editRoutineRefs (key) {
      this.$store.dispatch('dispatch/setRoutine', key).then(() => {
        this.$router.push({path: 'routines/reference'})
      })
    },
    addRoutineRefs () {
      this.$store.dispatch('dispatch/setRoutine', null).then(() => {
        this.$router.push({path: 'routines/reference'})
      })
    },
    editRoutineGroup (key) {
      this.$store.dispatch('dispatch/setRoutine', key).then(() => {
        this.$router.push({path: 'routines/group'})
      })
    },
    addRoutineGroup () {
      this.$store.dispatch('dispatch/setRoutine', null).then(() => {
        this.$router.push({path: 'routines/group'})
      })
    },
    editRoutine (key) {
      this.$store.dispatch('dispatch/setRoutine', key).then(() => {
        this.$router.push({path: 'routines/routine'})
      })
    },
    addRoutine () {
      this.$store.dispatch('dispatch/setRoutine', null).then(() => {
        this.$router.push({path: 'routines/routine'})
      })
    },
    youtube (id) {
      return 'https://www.youtube.com/embed/' + id
    },
    getGroup (ref) {
      const index = this.routineGroups.findIndex(group => group.key === ref)
      if (index !== -1) {
        return this.routineGroups[index].title
      }
      return ref
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    serviceLink (id) {
      return `routines/${id.toString()}`
    },
    rowClicked (item) {
      const serviceLink = this.serviceLink(item.index + 1)
      this.$router.push({path: serviceLink})
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Routines.vue